<template>
	<v-dialog v-model="dialog" width="360" v-if="logged_in" >
		<template v-slot:activator="{ on }">
			<v-btn x-small v-bind="size" :color="color" dark class="ml-2 mr-2" v-on="on"><v-icon small class="mr-3">mdi-logout-variant</v-icon>Log Out</v-btn>       
		</template>
		<v-card>
			<v-card-title>Log out</v-card-title>
			<v-card-text>
				Are you sure you want to log out?
			</v-card-text>
			<v-divider></v-divider>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn color="primary" text @click="logout">
					Log Out
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>    	
</template>

<script>
	import Vuex from 'vuex'
	export default{
		name: "LogoutModal", 
		props: ["size", "color"],
		data: () => {
			return {
				dialog: false
			}
		},
		computed: {
			...Vuex.mapState({
				view: state => state.auth.view,
				logged_in: state => state.auth.logged_in,
			}),
		},
		methods: {
			logout: function(){
				this.dialog = false;
				this.$store.dispatch('logout').then( () => {
					window.location = window.location.origin;
				})
				// if( this.$route.name !== "Home" ){
				// 	this.$router.push("/")
				// }
			}, 
		}

	}
</script>